import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles(({ palette, fontWeights }: Theme) => ({
  actions: {
    display: 'flex',
    gap: '0.75rem',
    marginTop: '2rem',
  },
  asterisk: {
    position: 'relative',
    top: 2,
    right: 0,
    color: palette.error.main,
    fontSize: '1.5rem',
    lineHeight: 1,
  },
  info: {
    marginBottom: '2rem',
    padding: '0.75rem',
    background: 'linear-gradient(286.95deg, #ffe7e9 1.2%, #e6f6ff 66.28%)',
    borderRadius: '1rem',
  },
  title: {
    margin: '0 0 0.75rem',
    fontWeight: fontWeights.medium,
    fontSize: '1.25rem',
    lineHeight: 1.4,
  },
  list: {
    margin: 0,
    paddingLeft: '1.5rem',
    '& li:first-child': {
      marginBottom: '0.5rem',
      fontWeight: fontWeights.medium,
    },
  },
}));
